// extracted by mini-css-extract-plugin
export default {"container":"AppSidebarExpedition_container_vvGdL","bottomContent":"AppSidebarExpedition_bottomContent_FLeBq","collapsed":"AppSidebarExpedition_collapsed_EBQ7g"};